import { useContext } from 'react';
import { ProfileContext } from './store';
// Services

import Services from './services';
// Actions
import * as Actions from './actions';

const useProfileState = () => {
  const [state, dispatch] = useContext(ProfileContext);
  const store = {
    state: { ...state },
    services: { ...Services(dispatch, Actions) },
  };

  return store;
};

export { useProfileState };
